import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export const FinalCTA = () => {
  return <Section data-id="element-175">
      <div className="max-w-3xl mx-auto text-center" data-id="element-176">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-177">
          La pregunta que tenés que hacerte
        </h2>

        <h3 className="text-2xl font-serif text-accent-light mb-8" data-id="element-178">
          ¿Cuántas noches más vas a dejar pasar?
        </h3>

        <div className="space-y-4 text-lg text-gray-300 mb-12" data-id="element-179">
          <p data-id="element-180">
            Cada noche que no dormís bien es una noche de vida que vivís a media
            máquina.
          </p>
          <p data-id="element-181">Mañana podés levantarte igual de agotado.</p>
          <p className="text-white font-medium" data-id="element-182">
            O podés empezar a cambiar esto esta noche.
          </p>
          <p data-id="element-183">El sistema está listo.</p>
          <p data-id="element-184">Las técnicas están ahí.</p>
          <p data-id="element-185">El Método Apagón Mental funciona.</p>
          <p className="text-xl text-white font-bold mt-6" data-id="element-186">
            Solo falta que lo uses.
          </p>
        </div>

        <div className="bg-night-900 border border-accent-blue/30 p-8 rounded-3xl mb-12 text-left max-w-xl mx-auto shadow-2xl" data-id="element-187">
          <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-188">
            Lo que llevan las personas que dicen sí hoy:
          </h4>
          <ul className="space-y-3 text-gray-300 mb-8" data-id="element-189">
            <li data-id="element-190">✅ 6 tomos del sistema completo</li>
            <li data-id="element-191">✅ 3 bonus exclusivos</li>
            <li data-id="element-192">✅ El Método Apagón Mental paso a paso</li>
            <li data-id="element-193">✅ Acceso inmediato</li>
            <li data-id="element-194">✅ 7 días de garantía</li>
            <li data-id="element-195">✅ Un sistema para siempre</li>
          </ul>
          <div className="text-center text-2xl font-bold text-white mb-6" data-id="element-196">
            <span className="text-gray-500 line-through text-xl mr-3" data-id="element-197">
              $39.000
            </span>
            Todo por <span className="text-cta" data-id="element-198">$19.999</span>
          </div>

          <Button href="#compra" fullWidth className="text-center" data-id="element-199">
            SÍ, QUIERO APAGAR LA CABEZA Y DORMIRME ESTA NOCHE
          </Button>
          <p className="text-center text-gray-500 text-xs mt-4" data-id="element-200">
            🔒 Pago seguro · Acceso instantáneo · Garantía de 7 días · PDF
            descargable
          </p>
        </div>

        {/* Cierre Emocional */}
        <div className="mt-20 pt-16 border-t border-night-700" data-id="element-201">
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-202">
            Una última cosa
          </h3>

          <div className="space-y-4 text-lg text-gray-400 mb-12" data-id="element-203">
            <p data-id="element-204">Tu cabeza no para porque nadie le enseñó a parar.</p>
            <p data-id="element-205">No es tu culpa.</p>
            <p data-id="element-206">No es que sos ansioso para siempre.</p>
            <p data-id="element-207">No es que algo está roto en vos.</p>
            <p className="text-white font-medium" data-id="element-208">
              Es que nunca tuviste el sistema correcto.
            </p>
            <p className="text-accent-light font-bold text-xl mt-6" data-id="element-209">
              Ahora lo tenés.
            </p>
          </div>

          <div className="bg-night-800/50 p-8 rounded-2xl italic text-gray-300 mb-12" data-id="element-210">
            <p className="mb-4" data-id="element-211">
              Cada persona que compró este sistema pensó lo mismo que vos en
              este momento.
            </p>
            <p className="mb-4" data-id="element-212">"¿Realmente va a funcionar para mí?"</p>
            <p className="mb-4" data-id="element-213">
              Y la respuesta que nos dieron fue siempre la misma:
            </p>
            <p className="text-xl text-white font-bold" data-id="element-214">
              "Ojalá lo hubiera comprado antes."
            </p>
          </div>

          <p className="text-2xl font-serif text-white mb-8" data-id="element-215">
            Esta noche puede ser diferente.
            <br data-id="element-216" />
            Depende de vos.
          </p>

          <Button href="#compra" variant="outline" className="mb-4" data-id="element-217">
            [APAGÁ LA CABEZA Y DORMITE — $19.999]
          </Button>
          <p className="text-gray-500 text-sm" data-id="element-218">
            🔒 Pago seguro · Acceso instantáneo · 7 días de garantía
          </p>
        </div>
      </div>
    </Section>;
};